import { render, staticRenderFns } from "./CardAssinatura.vue?vue&type=template&id=f5a3bb0e"
import script from "./CardAssinatura.vue?vue&type=script&lang=js"
export * from "./CardAssinatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports